// extracted by mini-css-extract-plugin
module.exports = {"coverImgContainer":"DetailHeader_coverImgContainer__3BYbm","navigation":"DetailHeader_navigation__1rPcG"};